<template>
  <f7-page>
    <f7-navbar back-link="Terug"></f7-navbar>
    <!--    <f7-block strong>-->
    <!--&lt;!&ndash;      <p>&ndash;&gt;-->
    <!--&lt;!&ndash;        Hi user id page&ndash;&gt;-->
    <!--&lt;!&ndash;      </p>&ndash;&gt;-->
    <!--      <p>-->
    <!--        {{ user.first_name }} {{ user.last_name }}-->
    <!--      </p>-->
    <!--    </f7-block>-->

    <template v-if="user">
      <f7-button
        class="m-3 py-4"
        raised
        fill
        @click="impersonateUser"
        v-if="!!current_user.is_admin"
      >
        Log in als lid
      </f7-button>


      <f7-card class="card-raised" bg-color="orange" outline title="NAW gegevens aanvullen">
        <f7-card-content>
          Welkom op de nieuwe account pagina! Hier staat alle informatie over je
          abonnement en jouw account. We missen nog een aantal gegevens van je -
          vul deze a.u.b. hier onder even in.
          <br /><br />
          Het is nu ook mogelijk per maand te betalen i.p.v. per 4 weken. Stuur
          even een feedback bericht als we dit voor je om kunnen zetten.
          <br /><br />
          Fijne dag!
        </f7-card-content>
      </f7-card>

      <f7-card class="private-gym-card card-raised">
        <f7-card-header class="no-border">
          <div class="private-gym-avatar">
            <img
              src="https://thispersondoesnotexist.com/image"
              width="34"
              height="34"
            />
          </div>
          <div class="private-gym-name">
            {{ user.name }}
            <f7-badge>
              {{ user.account_type }}
            </f7-badge>
            <f7-badge color="black" v-if="user.is_student"> Student </f7-badge>
          </div>
          <div class="private-gym-date">
            Account sinds: {{ user.created_at }}
          </div>
          <div class="private-gym-date">Laatste bezoek: {{ lastVisit }}</div>
        </f7-card-header>
        <f7-card-content>
          <f7-list class="list-strong list-outline list-dividers">
            <f7-list-input
              :value="user.first_name"
              @input="user.first_name = $event.target.value"
              label="Voornaam"
              type="text"
              placeholder=""
            ></f7-list-input>
            <f7-list-input
              :value="user.last_name"
              @input="user.last_name = $event.target.value"
              label="Achternaam"
              type="text"
              placeholder=""
            ></f7-list-input>
            <f7-list-input
              :value="user.email"
              @input="user.email = $event.target.value"
              label="Email"
              type="text"
              placeholder=""
            ></f7-list-input>
            <f7-list-input
              :value="user.phone_number"
              @input="user.phone_number = $event.target.value"
              label="Telefoon"
              type="text"
              placeholder=""
            ></f7-list-input>

            <f7-list-input
              :value="user.birthday"
              @input="user.birthday = $event.target.value"
              label="Verjaardag"
              type="date"
              placeholder=""
            ></f7-list-input>
            <f7-list-input
              :value="user.city"
              @input="user.city = $event.target.value"
              label="Woonplaats"
              placeholder=""
            ></f7-list-input>
            <f7-list-input
              :value="user.street_address"
              @input="user.street_address = $event.target.value"
              label="Straat"
              placeholder=""
            ></f7-list-input>
            <f7-list-input
              :value="user.postal_code"
              @input="user.postal_code = $event.target.value"
              label="Postcode"
              placeholder=""
            ></f7-list-input>
            <!--            <f7-list-input :value="user.country"-->
            <!--                           @input="user.country = $event.target.value"-->
            <!--                           label="Verjaardag" type="date" placeholder=""></f7-list-input>-->
            <!--            <f7-list-input :value="user.credits"-->
            <!--                           @input="user.credits = $event.target.value"-->
            <!--                           label="Credits" type="text" placeholder=""></f7-list-input>-->
          </f7-list>
        </f7-card-content>
        <f7-card-footer class="no-border">
          <div>{{ user.credits }} credits</div>
          <f7-button tonal @click="storeUser">Opslaan</f7-button>
        </f7-card-footer>
      </f7-card>

      <f7-block v-if="isManager">
        <f7-button class="my-3" raised fill @click="activateAccount"
          >Activeer account</f7-button
        >
        <f7-button class="my-3" raised fill @click="resetCredits"
          >Reset credits</f7-button
        >
      </f7-block>

      <template v-if="isManager">
        <f7-block-title strong> Kortingen </f7-block-title>
        <f7-card class="private-gym-card card-raised">
          <f7-card-content>
            <f7-list class="list-strong list-outline list-dividers">
              <f7-list-input
                :value="user.discount_percentage"
                @input="user.discount_percentage = $event.target.value"
                label="Korting in %"
                type="number"
                placeholder=""
              ></f7-list-input>
              <f7-list-item
                :value="!!user.is_student"
                :checked="!!user.is_student"
                @input="user.is_student = $event.target.checked"
                checkbox
                checkbox-icon="end"
                title="Student"
                name="studenten-korting"
              ></f7-list-item>

              <f7-list-item
                @click="openSelectDuoKortingUser = true"
                :title="discountUserName"
                header="Duo korting met"
                link="#"
              />
            </f7-list>
          </f7-card-content>
          <f7-card-footer class="no-border">
            <div></div>
            <f7-button tonal @click="storeDiscount">Opslaan</f7-button>
          </f7-card-footer>
        </f7-card>
      </template>

      <!--      <f7-card>-->
      <!--        <f7-card-header>-->
      <f7-block-title strong> Abonnementen </f7-block-title>
      <!--        </f7-card-header>-->
      <template v-if="user.subscriptions.length">
        <!--          <f7-list class="list-strong list-outline list-dividers">-->
        <!--            <f7-list-item link="#" title="Ivan Petrov" after="CEO" v-for="subscription in user.subscriptions">-->
        <!--              <template #media>-->
        <!--                <f7-icon icon="icon-f7" />-->
        <!--              </template>-->
        <!--            </f7-list-item>-->
        <!--          </f7-list>-->

        <!--
          `:expanded="isSelf"` -- the Betalingen accordion opens on arrival when
          this is the viewer's OWN record, and stays shut when an admin opens
          somebody else's (owner decision, 2026-08-20; finding F17).

          Deliberately NOT `index === 0` as on /account/abonnement. This page is
          "Instellingen": an admin arrives here to administer an account, and
          every card popping open would bury the controls they came for. A
          member arrives here from a payment notification.
        -->
        <template v-for="subscription in user.subscriptions">
          <user-subscription-details
            @updateSubscription="updateSubscription($event)"
            :subscription="subscription"
            :user="user"
            :expanded="isSelf"
          ></user-subscription-details>
        </template>
      </template>
      <f7-card class="card-raised" v-else>
        <f7-card-content>
          <em>Geen</em>
        </f7-card-content>
      </f7-card>

      <f7-card class="card-raised">
        <f7-card-header>
          Laatste 14 gym bezoeken
          <span class="badge bg-secondary">{{ user.total_visits }} totaal</span>
        </f7-card-header>
        <f7-card-content v-if="user.latest_visits.length">
          <template v-for="visit in user.latest_visits">
            <!--
              `mb-3` (16px) replaces the inter-row `<br />` that used to sit
              below this div. The card separated ROWS with the same glyph it
              uses INSIDE a soft-deleted row, which is already ambiguous at two
              lines; a row the sweep let go is THREE lines, at which point one
              booking reads as three. 42-UI-SPEC Spacing -- one utility, one
              value, and no CSS authored (H5: the style block at the bottom of
              this file is unscoped and leaks app-wide).
            -->
            <div
              class="mb-3"
              v-bind:class="{
                'text-muted': isInThePast(visit.start),
                'text-half-opacity': isInThePast(visit.start) && !visit.released_at,
                'text-danger': visit.deleted_at !== null && !visit.released_at,
              }"
            >
              <strong>{{ formattedDateTime(visit.start) }}</strong> -
              <span>{{ formattedDateTime(visit.stop) }}</span>
              <!--
                THE ORDER OF THESE TWO BRANCHES IS THE CONTRACT, NOT A STYLE.

                A row the sweep let go is soft-deleted as well -- the release
                columns are written and THEN the row is deleted -- so
                `visit.deleted_at !== null` is TRUE for it. Evaluate that
                condition first and every automatic release collapses into the
                member-cancellation branch below, and D-42-03's whole point (a
                member cancelling and the system letting a slot go must stay
                distinguishable in words, on the one surface that shows both)
                disappears with nothing red anywhere.

                42-UI-SPEC IC1: the two branches are mutually exclusive -- never
                both, never neither, for a soft-deleted row. Pinned by the
                mutual-exclusivity case in
                tests/components/account/UserId.test.js.

                (That case asserts the cancellation line is ABSENT from a
                released row by searching the rendered markup, and Vue keeps
                HTML comments in a dev render -- so this comment deliberately
                does not quote the authored strings it is about. Writing the
                test's own name here reds it, measured.)

                The two bindings above carry the other half of it: both gained
                `&& !visit.released_at` because a released row is future-start
                AND soft-deleted, which under the old bindings composited to
                #ff8080 on white -- 2.43:1, i.e. the whole record unreadable
                with no error anywhere (hazard H3). Muted-only is #6c757d,
                4.69:1, which passes AA.
              -->
              <template v-if="visit.released_at">
                <br /><span>{{ releaseLine(visit) }}</span>
                <template v-if="creditLine(visit)">
                  <br /><span>{{ creditLine(visit) }}</span>
                </template>
              </template>
              <!--
                D-42-08. The owner read 42-EVIDENCE, looked at this line and
                asked whether it meant the system or the user. It is a person,
                always -- the release branch above renders its own sentence, so
                this branch is never reached for a slot the sweep let go -- but
                the line could not say WHICH person, and the policy allows two:
                any admin, or the member on their own booking.

                One span and one method, exactly like the two lines above it.
                No second `<br />` was added: the row still has exactly one, and
                the spacing test counts them.
              -->
              <template v-else-if="visit.deleted_at !== null">
                <br /><span>{{ deletedLine(visit) }}</span>
              </template>
            </div>
          </template>
        </f7-card-content>
        <f7-card-content v-else>
          <em>Geen reserveringen gevonden</em>
        </f7-card-content>
      </f7-card>

      <template v-if="isManager">
        <f7-block-title strong> Notities </f7-block-title>
        <user-comments :user="user" @updateUser="user = $event"></user-comments>
      </template>

      <template v-if="isManager">
        <f7-block-title strong> Wachtwoord </f7-block-title>
        <admin-password-reset :user="user"></admin-password-reset>
      </template>

      <f7-popup
        v-model:opened="openSelectDuoKortingUser"
        @close="openSelectDuoKortingUser = false"
      >
        <f7-page>
          <f7-navbar title="Selecteer Duo Lid">
            <f7-nav-right>
              <f7-link popup-close>Sluiten</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <users-search
            @updated="duoKortingUsers = $event"
            :data="duoKortingUsers"
            :search-on-load="false"
            noMatchesString="Geen verdere matches gevonden "
          >
            <template v-slot:extra_items>
              <f7-list-item
                class="text-danger"
                @click="setDuoKorting(null)"
                title="Verwijder duo korting"
              >
                <f7-icon f7="trash" size="20px"></f7-icon>
              </f7-list-item>
            </template>
            <f7-list-item
              v-for="user in duoKortingUsers"
              @click="setDuoKorting(user)"
              :title="user.first_name + ' ' + user.last_name"
              :badge="user.account_type"
            >
            </f7-list-item>
          </users-search>
        </f7-page>
      </f7-popup>
    </template>
  </f7-page>
</template>

<script>
import { f7 } from "framework7-vue";
import moment from "moment";
import UserSubscriptionDetails from "@/components/account/users/UserSubscriptionDetails.vue";
import Utility from "@/js/utility";
import UserComments from "@/components/account/users/UserComments.vue";
import AdminPasswordReset from "@/components/account/users/AdminPasswordReset.vue";
import UsersSearch from "@/components/account/users/UsersSearch.vue";

export default {
  components: { UsersSearch, UserComments, AdminPasswordReset, UserSubscriptionDetails },

  props: {
    f7route: Object,
    f7router: Object,
  },

  mixins: [],

  data: function () {
    return {
      user: null,
      openSelectDuoKortingUser: false,
      duoKortingUsers: [],
    };
  },

  computed: {
    user_id() {
      return this.f7route.params.user_id;
    },
    current_user() {
      return this.$store.state.current_user.data;
    },
    discountUserName() {
      if (this.user.discount_user) {
        return (
          this.user.discount_user.first_name +
          " " +
          this.user.discount_user.last_name
        );
      }
      return "Niemand";
    },
    lastVisit() {
      if (this.user.latest_visits.length) {
        return this.user.latest_visits[0].start;
      }
      return "";
    },
    canEdit() {
      if (this.user_id === this.current_user.id || this.isManager) {
        return true;
      }
      return false;
    },
    isManager() {
      return this.current_user.is_admin;
    },

    /**
     * Is the record on screen the viewer's own? (40-09, finding F17.)
     *
     * NUMBER-COMPARED ON PURPOSE. `user_id` comes off the route and is always a
     * STRING; `current_user.data.id` comes off the API and is a NUMBER. The
     * `canEdit()` computed two lines above gets this exactly wrong -- it is
     * `this.user_id === this.current_user.id`, i.e. `'7' === 7`, which is false
     * for every member on their own record. Copying that shape here would leave
     * the accordion shut for everybody while the prop, the binding and the
     * component all looked correct.
     *
     * An id of 0 is treated as no id, matching the decision 40-05 recorded for
     * the deep link: `users.id` is AUTO_INCREMENT and starts at 1, so 0 is not a
     * member, and `Number(null)` is 0 -- without this an absent session would
     * read as "self" on the path /users/0.
     *
     * @returns {boolean}
     */
    isSelf() {
      const routeId = Number(this.user_id);
      const sessionId = Number(this.current_user ? this.current_user.id : NaN);

      if (!Number.isFinite(routeId) || !Number.isFinite(sessionId) || sessionId === 0) {
        return false;
      }

      return routeId === sessionId;
    },
  },

  created() {
    //
  },

  mounted() {
    this.fetchUser();
  },

  methods: {
    test(event) {
      // console.log('event', event);
    },
    isInThePast(date) {
      return moment().isBefore(moment(date));
    },
    formattedDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },

    /**
     * Line 2 of the release record (42-UI-SPEC S1, BOOK-06).
     *
     * Reuses formattedDateTime() rather than authoring a second date format --
     * a second format inside one card is how two dates get compared wrongly,
     * and this is the line an admin reads when a member disputes a release.
     *
     * NAMES NO ACTOR (IC4). No "verwijderd door", no admin name, and not
     * "Systeem" as a pseudo-person: a sweep has no authenticated principal at
     * all, and inventing one is the repudiation risk T-41-22 exists for. The
     * machine-readable trail stays in pg_logs.
     *
     * The stage clause is appended only when the server actually sent a stage,
     * so a partial payload degrades to a still-true sentence instead of
     * rendering the word "moment" followed by nothing (IC2). The client derives
     * nothing here: it does not read booking_stages and it never infers the
     * stage from the timestamp.
     *
     * @param {Object} visit one row of user.latest_visits
     * @returns {string}
     */
    releaseLine(visit) {
      const when = this.formattedDateTime(visit.released_at);

      if (visit.release_stage === null || visit.release_stage === undefined) {
        return `Automatisch vrijgegeven op ${when} — niet bevestigd`;
      }

      return `Automatisch vrijgegeven op ${when} — moment ${visit.release_stage}, niet bevestigd`;
    },

    /**
     * Line 3 of the release record: what actually happened to the credit.
     *
     * READS THE STORED OUTCOME. Never booking_stages, never a re-derivation
     * (D-42-01). A policy change applies forward only, so if the owner flips a
     * stage's credit policy next month every release from last month must still
     * read what happened at the time. A record that re-derives itself from
     * current config is not a record.
     *
     * null/absent -> null, and the caller renders no credit line at all rather
     * than guessing one (IC2).
     *
     * `Number(...) > 0` is deliberately SHAPE-AGNOSTIC and must not be
     * "simplified" to a truthiness check. The column ships as a
     * decimal(8,2) holding the AMOUNT credited with 0.00 meaning forfeit
     * (owner decision, 42-01 checkpoint), which arrives on the wire as the
     * string "0.00" -- truthy. A truthiness check would therefore read every
     * forfeit as a refund, and would also break in the other direction if the
     * column ever became a boolean.
     *
     * @param {Object} visit one row of user.latest_visits
     * @returns {?string}
     */
    creditLine(visit) {
      if (
        visit.release_credit_refunded === null ||
        visit.release_credit_refunded === undefined
      ) {
        return null;
      }

      return Number(visit.release_credit_refunded) > 0
        ? "Credit teruggestort."
        : "Credit vervallen.";
    },

    /**
     * The cancellation line, and WHO did it (D-42-08, BOOK-06).
     *
     * The owner asked of 42-EVIDENCE whether `Verwijderd op` meant the system or
     * the user. Measured answer: a person, always -- an automatic release takes
     * the `visit.released_at` branch and renders its own sentence, so this line
     * is never reached for one. But `TrainingSlotPolicy::destroy()` allows two
     * actors, any admin or the member on their own booking, and a member saw
     * identical wording for "I cancelled this" and "the gym cancelled this for
     * me".
     *
     * THREE CASES. The server supplies facts; this method supplies the Dutch.
     *
     *   the VIEWER cancelled it      -> `Verwijderd op: {date} door jou`
     *   somebody else cancelled it   -> `Verwijderd op: {date} door {name}`
     *   no actor stored              -> `Verwijderd op: {date}` -- unchanged
     *
     * COMPARED AGAINST THE VIEWER, NOT AGAINST THE PAGE'S USER, and that is why
     * the server sends two facts instead of one rendered sentence. `door jou`
     * depends on WHO IS LOOKING: the same stored row -- "member 1190 cancelled
     * this" -- must read `door jou` to member 1190 and `door Test Lid` to an
     * admin, and the server cannot know which request will render it.
     *
     * NUMBER-COMPARED, for the reason `isSelf()` above documents at length
     * (finding F17): identifiers arrive here from two sources with two types,
     * and `canEdit()` two computeds up is the live example of `'7' === 7` being
     * false for every member on their own record. An id of 0 is treated as no
     * id -- `users.id` is AUTO_INCREMENT from 1, and `Number(null)` is 0, so
     * without that an absent session would read as "self".
     *
     * THE NULL CASES ARE NOT A FALLBACK, THEY ARE THE ANSWER. Two of them, both
     * permanent: every row deleted before 2026-08-31 (there is no backfill and
     * there never will be -- the only trace is PgLog free text, and parsing it
     * would invent facts), and every automatic release (a system release is not
     * a person, T-41-22). An actor id whose name did not arrive degrades the
     * same way, rather than rendering "door null" -- IC2's rule: a partial
     * payload produces a still-true sentence, never a broken one.
     *
     * @param {Object} visit one row of user.latest_visits
     * @returns {string}
     */
    deletedLine(visit) {
      const line = `Verwijderd op: ${this.formattedDateTime(visit.deleted_at)}`;

      const actorId = Number(
        visit.deleted_by_user_id === null || visit.deleted_by_user_id === undefined
          ? NaN
          : visit.deleted_by_user_id,
      );

      if (!Number.isFinite(actorId) || actorId === 0) {
        return line;
      }

      const viewerId = Number(this.current_user ? this.current_user.id : NaN);

      if (Number.isFinite(viewerId) && viewerId !== 0 && viewerId === actorId) {
        return `${line} door jou`;
      }

      if (typeof visit.deleted_by_name === "string" && visit.deleted_by_name.trim() !== "") {
        return `${line} door ${visit.deleted_by_name}`;
      }

      return line;
    },
    impersonateUser() {
      let vm = this;
      if (vm.current_user.is_admin === 1) {
        f7.dialog.confirm(
          `Are you sure to impersonate as this user (${this.user.first_name} ${this.user.last_name})?`,
          function () {
            vm.$store.dispatch('current_user/impersonate', {
              user: vm.user_id,
            }).then(response => {
              vm.f7router.navigate('/');
              vm.$store.dispatch("notifications/addSuccessNotification", {
                message: "Impersonated successfully",
              });
            })
          }
        );
      }
    },
    activateAccount() {
      let vm = this;
      f7.dialog.confirm(
        "Wil je het account activeren van " + this.user.name + "?",
        function () {
          vm.$store.commit("app/show_loader");
          vm.$store
            .dispatch("api/postEndpoint", {
              endpoint: "/users/" + vm.user_id + "/activate",
            })
            .then((response) => {
              vm.$store.dispatch("notifications/addSuccessNotification", {
                message: "Het account is geactiveerd",
              });
              vm.user = response.data.data;
            })
            .finally(() => {
              vm.$store.commit("app/hide_loader");
            });
        }
      );
    },
    resetCredits() {
      let vm = this;
      f7.dialog.confirm(
        "Wil je de credits resetten van " + this.user.name + "?",
        function () {
          vm.$store.commit("app/show_loader");
          vm.$store
            .dispatch("api/postEndpoint", {
              endpoint: "/users/" + vm.user_id + "/activate",
              data: {
                reset_credits: true,
              },
            })
            .then((response) => {
              vm.$store.dispatch("notifications/addSuccessNotification", {
                message: "De credits zijn gereset",
              });
              vm.user = response.data.data;
            })
            .finally(() => {
              vm.$store.commit("app/hide_loader");
            });
        }
      );
    },
    fetchUser() {
      if (this.user_id !== 'undefined') {
        this.$store.commit("app/show_loader");
        this.$store
          .dispatch("api/getEndpoint", {
            endpoint: "/users/" + this.user_id,
            data: {
              query: this.query,
            },
          })
          .then((response) => {
            this.user = response.data.data;
          })
          .finally(() => {
            this.$store.commit("app/hide_loader");
          });
      }
    },
    storeUser() {
      this.$store.commit("app/show_loader");
      this.$store
        .dispatch("api/postEndpoint", {
          endpoint: "/users/" + this.user_id,
          data: {
            user: this.user,
          },
        })
        .then((response) => {
          // If it's the same user, we update the current_user as well
          this.user = response.data.data;
          if (this.user.id === this.current_user.id) {
            this.$store.dispatch("current_user/fetch");
          }
        })
        .catch(() => {
          // api/onError has already shown the toast (422 error bag, or the
          // server's message on 5xx). The form keeps the admin's input so the
          // address can be corrected. Without this catch the rejection reached
          // window.onunhandledrejection and Sentry (issue 7400715489).
        })
        .finally(() => {
          this.$store.commit("app/hide_loader");
        });
    },
    storeDiscount() {
      this.$store.commit("app/show_loader");
      this.$store
        .dispatch("api/postEndpoint", {
          endpoint: "/users/" + this.user_id + "/discount",
          data: {
            discount_user_id: this.user.discount_user
              ? this.user.discount_user.id
              : null,
            discount_percentage: this.user.discount_percentage,
            is_student: this.user.is_student ? 1 : 0,
          },
        })
        .then((response) => {
          this.user = response.data.data;
        })
        .finally(() => {
          this.$store.commit("app/hide_loader");
        });
    },
    updateSubscription(subscription) {
      let index = Utility.find_index_of_matching_element(
        this.user.subscriptions,
        "id",
        subscription.id
      );

      this.user.subscriptions[index] = subscription;
    },
    setDuoKorting(user) {
      this.user.discount_user = user;
      this.openSelectDuoKortingUser = false;
    },
  },

  watch: {
    'user.is_student': {
      handler(is_student) {
        if (is_student) {
          this.user.discount_percentage = 33;
        }
        else {
          this.user.discount_percentage = this.user.discount_percentage || 0;
        }
      }
    }
  },
};
</script>
<style>
.demo-card-header-pic .card-header {
  height: 40vw;
  background-size: cover;
  background-position: center;
  color: #fff;
}

.demo-card-header-pic .card-content-padding .date {
  color: #8e8e93;
}

.private-gym-card .card-header {
  display: block;
  padding: 10px;
}

.private-gym-card .private-gym-avatar {
  float: left;
}

.private-gym-card .private-gym-name {
  margin-left: 44px;
  font-size: 14px;
  font-weight: 500;
}

.private-gym-card .private-gym-date {
  margin-left: 44px;
  font-size: 13px;
  color: #8e8e93;
}

.private-gym-card .card-footer {
  background: #fafafa;
}

.dark .private-gym-card .card-footer {
  background-color: transparent;
}

.private-gym-card .card-footer a {
  color: #81848b;
  font-weight: 500;
}

.private-gym-card .card-content img {
  display: block;
}

.private-gym-card .card-content-padding {
  padding: 15px 10px;
}

.private-gym-card .card-content-padding .likes {
  color: #8e8e93;
}
</style>
